<template>
  <div ref="rootElement">
    <div class="flex flex-center">
      <tm-tabs
        class="tm-faq-tabs__tm-tabs"
        :model-value="modelValue"
        :tabs="tabs"
        tab-style="pills"
        no-border
        @update:model-value="$emit('update:model-value', $event)"
      />
    </div>
    <div class="mt-4">
      <component
        :is="activeTab.component"
        :params="tabParams"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { ref, computed, defineComponent, type PropType } from '@/composition/vue/compositionApi'
import TmTabs from '@/components/shared/TmTabs.vue'
import { DefaultInputEvent } from '@/services/forms/types'
import type { ITmFaqTab } from '@/components/shared/types'

export default defineComponent({
  components: {
    TmTabs,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    tabs: {
      type: Array as PropType<ITmFaqTab<string>[]>,
      required: true,
    },
    tabParams: {
      type: Object,
    },
  },
  emits: {
    [DefaultInputEvent]: (_value: string) => true,
  },
  setup(props) {
    const rootElement = ref<HTMLDivElement | null>(null)
    const activeTab = computed(() => props.tabs.find((t) => t.name === props.modelValue)!)

    const scrollIntoView = (arg?: boolean | ScrollIntoViewOptions) => {
      rootElement.value!.scrollIntoView(arg)
    }

    return {
      rootElement,
      activeTab,
      scrollIntoView,
    }
  },
})
</script>
